import React from 'react';

// Default value is defined in MetadataContextProvider
export const MetadataContext = React.createContext({});
